module.exports = __webpack_public_path__ + "img/satellite.dc80d224.svg";